import SectionHeader from "../../components/commonUi/SectionHeader";

const Dashboard = () => {
  return (
    <div className="px-7">
      <SectionHeader
        title={"Dashboard"}
        objective={"Monitor and Analyze key data metrices and KPIs."}
      />

      <p className="flex justify-center items-center mt-56 text-xl text-gray-500">
        Work on progress ...
      </p>
    </div>
  );
};

export default Dashboard;
